<template>
  <SntSelect
    :value="value"
    :width="width"
    :height="height"
    :items="filteredItems"
    :loading="$apollo.loading"
    :has-next-page="resellers.hasNextPage"
    :callback="fetchMore"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    item-text="name"
    item-value="id"
    hide-details
    @input="$emit('input', $event)" />
</template>

<script>
import gql from 'graphql-tag'
import SntSelect from '../form/SntSelect.vue'

export default {
  components: {
    SntSelect
  },
  props: {
    value: {
      type: [Boolean, String],
      default: null
    },
    placeholder: {
      type: String,
      default: 'ทั้งหมด'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    ignoreValues: {
      type: Array,
      default: () => ([])
    },
    selectFirst: Boolean,
    clearable: Boolean,
    disabled: Boolean
  },
  apollo: {
    resellers: {
      fetchPolicy: 'network-only',
      query: gql`query getResellers {
        resellers {
          hasNextPage
          nodes {
            id
            name
          }
        }
      }`,
      variables () {
        return {
          page: 1,
          perPage: this.perPage,
          orderBy: 'id_ASC'
        }
      },
      result ({ data }) {
        this.onLoaded(data)
        if (this.selectFirst) {
          this.selectFirstStock()
        }
      }
    }
  },
  data () {
    return {
      page: 1,
      perPage: 25,
      resellers: {
        nodes: [],
        hasNextPage: false
      }
    }
  },
  computed: {
    filteredItems () {
      let items = this.resellers.nodes
      if (this.ignoreValues?.length) {
        items = items.filter((item) => !this.ignoreValues?.includes(item.id))
      }
      return items
    }
  },
  watch: {
    ignoreValues () {
      if (this.selectFirst) {
        this.selectFirstStock()
      }
    }
  },
  methods: {
    async fetchMore () {
      this.page += 1
      await this.$apollo.queries.resellers.fetchMore({
        variables: {
          page: this.page,
          perPage: this.perPage
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const { hasNextPage, nodes } = fetchMoreResult.resellers
          return ({
            resellers: {
              __typename: previousResult.resellers.__typename,
              nodes: this.$_.uniqBy([
                ...previousResult.resellers.nodes,
                ...nodes
              ], 'id'),
              hasNextPage
            }
          })
        }
      })
    },
    onLoaded (data) {
      this.$emit('loaded', data)
    },
    selectFirstStock () {
      if (this.value) return
      let value = null
      const main = this.$_.head(this.filteredItems)
      if (main) {
        value = main.id
      }
      this.$emit('input', value)
    }
  }
}
</script>
